<template>
    <collapsible-card :title="'Leases'" v-show="showLeases" ref="cCard">
        <div class="cardContent">
            <table class="staticTable">
                <thead>
                    <tr>
                        <th scope="col">Lease Number</th>
                        <th scope="col">Block</th>
                        <th scope="col">Companies</th>
                        <th scope="col">Operator</th>
                        <th scope="col">Effective Date</th>
                    </tr>
                </thead>
                <tbody>
                   <tr v-for="obj in leases" :key="obj.leaseNum">
                       <td data-label="Lease Number">
                           <router-link :to="{name: 'Leases', params: {lease: obj.leaseNum}}" class="link">{{obj.leaseNum}}</router-link>
                       </td>
                       <td data-label="Block">
                           {{obj.block}}
                       </td>
                       <td data-label="Companies">
                           {{obj.companies.join(', ')}}
                       </td>
                       <td data-label="Operator">
                           {{obj.operator}}
                       </td>
                       <td data-label="Effective Date">
                           {{obj.effectiveDateLT}}
                       </td>
                   </tr>
                </tbody>
            </table>
        </div>
    </collapsible-card>
</template>

<script>
import { formatDateLT } from '../../helpers/Formatting.js';
import CollapsibleCard from '../CollapsibleCard.vue';

export default {
    name: 'op-leases',
    components: {
        CollapsibleCard
    },
    data: () => ({
        showLeases: false,
        leases: []
    }),
    methods: {
        updateInfo: function(leaseInfo) {
            var globv = this;
            globv.leases = leaseInfo.map(x => {
                if (x['effectiveDate'])
                    x['effectiveDateLT'] = formatDateLT(x['effectiveDate']);
                
                return x;
            });

            globv.showLeases = globv.leases.length > 0;

            globv.$refs.cCard.adjustHeight();
        },
        reset: function() {
            var globv = this;
            globv.showLeases = false;
            globv.leases = [];
        }
    }
}
</script>